import API from '../../../../services/apiService.js'

var api= new API();


export default {

  //загрузить года выпуска
  async loadYears({commit}, modelId){
    var data = null;
    try {
      let getParams=`?CarModelId=${modelId}`
      data = await api.Get("DirectoryService/CarModel/GetAvalibleYears"+getParams);
      commit('loadYears', {modelId: modelId, data: data});
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  // Загрузить данные по маркам
  async loadMarks({commit}) {
    var data = null;
    try {
      data = await api.Get("DirectoryService/CarMark");
      commit('loadMarks', data);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  // Загрузить список моделей выбранной марки
  async loadModels({commit}, markId) {
    var data = null;
    try {
      var params = `?CarMarkId=${markId}`;
      data = await api.Get("DirectoryService/CarModel/GetAllByCarMarkId" + params);
      commit('loadModels', {markId: markId, data: data});
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //добавить модель
  async addModel({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("DirectoryService/CarModel", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("DirectoryService/CarModel/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addModel', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //добавить марку
  async addMark({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("DirectoryService/CarMark", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("DirectoryService/CarMark/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addMark', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //редактировать марку
  async editMark({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      await api.Put("DirectoryService/CarMark", data);
      var getparams = '?Id=' + data.id;
      newData = await api.Get("DirectoryService/CarMark/GetById" + getparams)

      if (newData != null && newData != "")
        commit('editMark', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //редактировать модель
  async editModel({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      await api.Put("DirectoryService/CarModel", data);
      var getparams = '?Id=' + data.id;
      newData = await api.Get("DirectoryService/CarModel/GetById" + getparams)

      if (newData != null && newData != "")
        commit('editModel', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить марку
  async deleteMark({commit}, markId) {
    try {
      var getparams = '?carMarkId=' + markId;
      await api.Delete("DirectoryService/CarMark", getparams);
      commit('deleteMark', markId);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить модель
  async deleteModel({commit}, params) {
    try {
      var getparams = '?CarModelId=' + params.modelId;
      await api.Delete("DirectoryService/CarModel", getparams);
      commit('deleteModel', params);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

}
